// Third party and libraries
import React, { useState } from 'react';
import { Card, Button, ListGroup, Badge, Form, Modal, InputGroup } from 'react-bootstrap';
import { COLOR_APP, COLOR_WHITE } from '../../constants';
import { FaArrowRight } from 'react-icons/fa';
import { IoArrowBack } from 'react-icons/io5';
import { IoMdAdd } from 'react-icons/io';
import { MdSave } from 'react-icons/md';
import { FiBox } from 'react-icons/fi';

export default function StepAddAddress({ setActiveTab, orderGroupData, setPrepareDatas }) {
  // State 
  const [selectedPosition, setSelectedPosition] = useState({
    lat: 17.96667,
    lng: 102.6,
  });
  const [openAddAddress, setOpenAddAddress] = useState(false);
  const [tabAddressFields, setTabAddressFields] = useState({
    customerName: orderGroupData?.cfName || orderGroupData?.customerName || "",
    phone: "",
    // address: ""
  })
  // Map container style
  const mapContainerStyle = {
    width: '100%',
    height: '400px',
  };

  // Handle click event to get the coordinates from the map
  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setSelectedPosition({ lat, lng });
  };

  // Confirm button handler to log the selected coordinates
  const handleConfirmAddress = () => {
    alert(`Selected coordinates: Latitude: ${selectedPosition.lat}, Longitude: ${selectedPosition.lng}`);
    // You can perform additional actions, such as saving the address or using a geocoding API
  };

  const onCloseAddNewAddress = () => {
    setOpenAddAddress(false)
  }

  const handleSubmitAddressTab = () => {

    console.log({ tabAddressFields })

    // setActiveTab('payment-order')  
  }

  return (
    <React.Fragment>
      <Card style={{ boxShadow: 'none', background: COLOR_WHITE }}>
        <Card.Body>
          <h5><FiBox /> ທີ່ຢູ່ປາຍທາງ</h5>

          <ListGroup as="ol" numbered>
            <ListGroup.Item
              as="li"
              className="d-flex justify-content-between align-items-start border hover"
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold"><b>ອານຸສິດ</b></div>
                ໜອງແຕ່ງ, ໜອງແຕ່ງເໜືອ, ສີໂຄດຕະບອງ, ນະຄອນຫລວງວຽງຈັນ
              </div>
              <Form.Check
                inline
                type="radio"
                id="inline-radio"
                className='mt-3'
                style={{ scale: 3 }}
              />
            </ListGroup.Item>
            <ListGroup.Item
              as="li"
              className="d-flex justify-content-between align-items-start border hover"
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold">Subheading</div>
                Cras justo odio
              </div>
              <Form.Check
                inline
                type="radio"
                id="inline-radio"
                className='mt-2'
                size="lg"
              />
            </ListGroup.Item>
            <ListGroup.Item
              as="li"
              className="d-flex justify-content-between align-items-start border"
            >
              <div className="ms-2 me-auto">
                <div className="fw-bold">Subheading</div>
                Cras justo odio
              </div>
              <Form.Check
                inline
                type="radio"
                id="inline-radio"
                className='mt-2'
                size="lg"
              />
            </ListGroup.Item>
          </ListGroup>

          <Button variant="outline-info" style={{ marginTop: '1em', }} onClick={() => setOpenAddAddress(true)}>
            <IoMdAdd /> ເພິ່ມທີ່ຢູ່
          </Button>


          <div className='card-info-customer'>
            <h5><FiBox /> ຂໍ້ມູນຕິດຕໍ່ໄດ້</h5>
            <Form.Group className="mb-3" controlId="fullname.controlInput">
              <Form.Label>ຊື່ລູກຄ້າ (ຈຳເປັນ)</Form.Label>

              <Form.Control
                value={tabAddressFields.customerName}
                onChange={(e) => setTabAddressFields({
                  ...tabAddressFields,
                  customerName: e?.target?.value
                })}
                type="text"
                placeholder="ປ້ອນຊື່ຜູ້ຊື້"
              />

            </Form.Group>

            <Form.Group controlId="phone.controlInput">
              <Form.Label>ເບີໂທລະສັບ (ຈຳເປັນ)</Form.Label>
              <InputGroup className="w-100" style={{marginLeft:'-1em'}}>
                <InputGroup.Text id="basic-addon1">020</InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="000"
                  aria-label="phone"
                  aria-describedby="basic-addon1"
                  value={tabAddressFields.phone}
                  onChange={(e) => {
                    let _valuePhone = e?.target?.value
                    if (_valuePhone?.length > 8) return;
                    setTabAddressFields({
                      ...tabAddressFields,
                      phone: _valuePhone
                    })
                  }}
                />
              </InputGroup>
            </Form.Group>

            <div className='d-flex w-100 justify-content-end gap-4 mt-4'>
              <Button variant='ligth' onClick={() => setActiveTab('order-detail')}>
                <IoArrowBack /> ກັບຄືນ
              </Button>
              <Button variant='primary' onClick={handleSubmitAddressTab} style={{ background: COLOR_APP, color: COLOR_WHITE, border: 'none' }}>ຖັດໄປ <FaArrowRight /></Button>
            </div>
          </div>
        </Card.Body>
      </Card>

      <Modal centered show={openAddAddress} onHide={onCloseAddNewAddress}>
        <Modal.Header closeButton>
          <Modal.Title>ເພິ່ມທີ່ຢູ່ປາຍທາງຂອງຂ້ອຍໃໝ່</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3" controlId="logictis.controlInput">
            <Form.Label>ເລືອກຂົນສົ່ງ</Form.Label>
            <Form.Select>
              <option>-ເລືອກ-</option>
              <option value="anusid">ອານຸສິດ</option>
              <option value="hal">ຮຸ່ງອາລຸນ</option>
              <option value="mixay">ມີໄຊ</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="province.controlInput">
            <Form.Label>ແຂວງ</Form.Label>
            <Form.Select>
              <option>-ເລືອກ-</option>
              <option value="anusid">ອານຸສິດ</option>
              <option value="hal">ຮຸ່ງອາລຸນ</option>
              <option value="mixay">ມີໄຊ</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="district.controlInput">
            <Form.Label>ເມືອງ</Form.Label>
            <Form.Select>
              <option>-ເລືອກ-</option>
              <option value="anusid">ອານຸສິດ</option>
              <option value="hal">ຮຸ່ງອາລຸນ</option>
              <option value="mixay">ມີໄຊ</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3" controlId="brand.controlInput">
            <Form.Label>ສາຂາ</Form.Label>
            <Form.Select>
              <option>-ເລືອກ-</option>
              <option value="anusid">ອານຸສິດ</option>
              <option value="hal">ຮຸ່ງອາລຸນ</option>
              <option value="mixay">ມີໄຊ</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="info" onClick={onCloseAddNewAddress}>
            <MdSave /> Save
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
